export const UPDATE_AWS_DIALER_VISIBILITY = 'awsConnect/UPDATE_AWS_DIALER_VISIBILITY';
export const UPDATE_CONTACT_TO_DIAL = 'awsConnect/UPDATE_CONTACT_TO_DIAL';
export const UPDATE_AGENT_STATE = 'awsConnect/UPDATE_AGENT_STATE';
